import { EventEmitter, Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class MouseMoveService  {
    mouseMove: EventEmitter<boolean> = new EventEmitter<boolean>();

    mouseMoveEvent(){
        this.mouseMove.emit(true);
    }
}